// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__27GnL","header":"ReportDetails_header__Q4kKq","title":"ReportDetails_title__1t-LD","left":"ReportDetails_left__2mjpu"};